var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26.0011207px",
    height: "25.9996499px",
    viewBox: "0 0 26.0011207 25.9996499",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:user-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NCOB-Settings-Quick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC-OB-General-On-Setup",
    transform: "translate(-318.7488, -1277.0004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:user-circle",
    transform: "translate(315.75, 1274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993333,3.00039329 C21.3958877,3.00039329 26.2312859,6.33447658 28.1499509,11.3784357 C30.068616,16.4223949 28.6715263,22.1272461 24.6392778,25.7138561 C22.2621052,27.8342486 19.1854175,29.0045359 16.0015306,29.0000281 C12.8141961,29.0048914 9.73693257,27.8345807 7.35834821,25.7129292 L7.06192181,25.4409321 C3.25935825,21.8424166 1.97801732,16.2962959 3.84871572,11.3784357 C5.76738075,6.33447658 10.6027789,3.00039329 15.9993333,3.00039329 Z M15.9990931,21.9999918 C13.5469366,21.9977715 11.2176006,22.9968522 9.53415665,24.737101 L9.44414941,24.8323933 L9.68464621,25.009329 C11.4101253,26.22144 13.4551492,26.9135227 15.5762556,26.9924357 L16.0014192,27.0000262 C18.2707607,27.0032358 20.4740492,26.301968 22.314193,25.0092155 L22.5548161,24.8323933 L22.4658393,24.737101 C20.8665421,23.0838646 18.6841658,22.0995325 16.3661565,22.0071391 L15.9990931,21.9999918 Z M15.9993333,5.00039329 C11.4330181,5.00039329 7.3415273,7.82154069 5.71804151,12.0895061 C4.23371164,15.991646 5.09466662,20.361245 7.8607729,23.4010698 L7.95214941,23.4977266 L7.99060384,23.4577173 C9.96659303,21.3569112 12.7006429,20.1089217 15.602413,20.006793 L15.9990931,19.9999963 C19.0490316,19.9972302 21.9435651,21.26142 24.0093934,23.4577173 L24.0454827,23.4977266 L24.1378938,23.4010698 C26.8175592,20.4562395 27.7092848,16.2634473 26.4129236,12.4566464 L26.2806252,12.0895061 C24.6571394,7.82154069 20.5656486,5.00039329 15.9993333,5.00039329 Z M16,8 C18.7614237,8 21,10.2385763 21,13 C21,15.7614237 18.7614237,18 16,18 C13.2385763,18 11,15.7614237 11,13 C11,10.2385763 13.2385763,8 16,8 Z M16,10 C14.3431458,10 13,11.3431458 13,13 C13,14.6568542 14.3431458,16 16,16 C17.6568542,16 19,14.6568542 19,13 C19,11.3431458 17.6568542,10 16,10 Z",
    id: "Shape",
    fill: "#192340",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/Services.22029316c20eddbba18f1f4b35e47b8f.svg";
export { ForwardRef as ReactComponent };